module.exports = __webpack_public_path__ + "static/media/spy.340329f8.svg";